type ParamsQueryString = {
  [key: string]: string
}

const reduceParamsToQueryParams = (params: ParamsQueryString) =>
  Object.entries(params)
    .map((value) => `${value[0]}=${value[1]}`)
    .join("&")

export const replaceParamInQueryString = (
  queryParams: ParamsQueryString,
  param: string,
  newValue: string
) => {
  queryParams[param] = newValue
  return `?${reduceParamsToQueryParams(queryParams)}`
}

export const replaceMcOrigenWithValueABTesting = (
  queryParams: ParamsQueryString,
  newHome: boolean
) => {
  const newValueMcOrigen = newHome ? "Nuevo-Sitio-2023" : "Antiguo-Sitio-2020"
  return replaceParamInQueryString(queryParams, "mc_origen", newValueMcOrigen)
}
